var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "medical-analyses-list" },
    [
      _c("medical-analyses-sidesheet", {
        ref: "modal",
        on: { "delete-type": _vm.onRemoveGroup, update: _vm.reload },
      }),
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _vm.loading
        ? _c("c-loader", {
            attrs: { label: "", active: _vm.loading, height: "500" },
          })
        : _vm._e(),
      !_vm.loading
        ? _c("div", [
            _vm.hasVisibleItems
              ? _c(
                  "div",
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "item-container",
                        attrs: {
                          tag: "div",
                          "ghost-class": "sortable__ghost",
                          "chosen-class": "sortable-chosen",
                          group: "list",
                          "force-fallback": true,
                        },
                        on: { change: _vm.resortAnalyses },
                        model: {
                          value: _vm.analyseGroups,
                          callback: function ($$v) {
                            _vm.analyseGroups = $$v
                          },
                          expression: "analyseGroups",
                        },
                      },
                      _vm._l(_vm.analyseGroups, function (group) {
                        return _c(
                          "div",
                          {
                            key: group.id,
                            staticClass: "item-group",
                            attrs: { "data-type": "group" },
                          },
                          [
                            _c("medical-analyses-group", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAnalyseVisible(group),
                                  expression: "isAnalyseVisible(group)",
                                },
                              ],
                              attrs: {
                                group: group,
                                query: _vm.normalizedQuery,
                              },
                              on: {
                                "remove-analyse": _vm.onAnalyseRemove,
                                "edit-group": _vm.onEditGroup,
                                "remove-group": _vm.onRemoveGroup,
                                resort: _vm.resortAnalyses,
                                "add-analyse": _vm.onAddingAnalyse,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "documents-list__empty" }, [
                  _vm._v(
                    "Ничего не найдено. Попробуйте изменить параметры поиска."
                  ),
                ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }